import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const ToggleItemSC = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_40});
  width: 100%;

  ${MEDIA.MAX_599} {
    padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_30});
  }
`
